import { FC, useMemo } from "react";
import { TaskType } from "@myapp/contract";
import Select from "../../../shared/ui/controls/Select/Select";
import { taskTypeOptions } from "../model/taskType";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const ALL_OPTION: ISelectOption = { value: null, label: "Alle Aufgabentypen" };

interface TaskTypeSelectProps {
  value?: TaskType | null;
  onChange?: (value: TaskType | null) => void;
  withAllOption?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: string | null;
  size?: "md" | "sm";
}

const TaskTypeSelect: FC<TaskTypeSelectProps> = ({
  value,
  onChange,
  withAllOption = false,
  placeholder = "Aufgabentyp wählen",
  className,
  disabled,
  error,
  size,
}) => {
  const options = useMemo(
    () => (withAllOption ? [ALL_OPTION, ...taskTypeOptions] : taskTypeOptions),
    [withAllOption],
  );

  return (
    <Select
      options={options}
      value={value ?? null}
      onChange={(v) => onChange?.(v as TaskType | null)}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      error={error}
      size={size}
    />
  );
};

export default TaskTypeSelect;
